import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { useTrackedLocation } from "../../UserState"
import { useSnackbar } from "notistack"
import { changePaymentAmount, sendPayment } from "./PaymentModalFunctions"

export default function BlockchypPaymentModal({
    open,
    closeModal,
    invoice,
    amount
}) {
    const [selectedLocation,] = useTrackedLocation();
    const { enqueueSnackbar } = useSnackbar();
    const [paymentAmount, setPaymentAmount] = React.useState(amount)
    const [checkoutPayingStep, setCheckoutPayingStep] = React.useState(0)
    const [selectedBlockchypTerminal, setSelectedBlockchypTerminal] = React.useState(localStorage.getItem(`selected_blockchyp_terminal:location_${selectedLocation.id}`) || (selectedLocation?.integrations?.BLOCKCHYP?.TERMINAL_NAMES || [])[0])
    const mySendPayment = sendPayment(setCheckoutPayingStep, enqueueSnackbar, closeModal)
    const mychangePaymentAmount = changePaymentAmount(setPaymentAmount, amount)

    const submit = (e) => {
        e.preventDefault();
        mySendPayment('BLOCKCHYP', invoice.id, paymentAmount.toFixed(2), selectedLocation.id, { selected_terminal: selectedBlockchypTerminal })
    }

    React.useEffect(() => {
        if (open) {
            setPaymentAmount(Math.round(amount * 100) / 100)
            setSelectedBlockchypTerminal(localStorage.getItem(`selected_blockchyp_terminal:location_${selectedLocation.id}`) || (selectedLocation?.integrations?.BLOCKCHYP?.TERMINAL_NAMES || [])[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amount, open])

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='xs'
                fullWidth
            >
                <LoadingBackdropIndeterminate
                    open={checkoutPayingStep > 0}
                    text={"Submitting Payment"}
                />
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>BlockChyp Payment</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container direction={'column'} spacing={3}>
                            <Grid item>
                                <TextField
                                    margin="dense"
                                    id="paymentamount"
                                    label="Payment Amount"
                                    type="number"
                                    fullWidth
                                    variant="standard"
                                    value={paymentAmount.toString()}
                                    onChange={mychangePaymentAmount}
                                    sx={{ minWidth: '125px' }}
                                    slotProps={{
                                        input: {
                                            inputProps: { min: Math.min(0, Math.round(amount * 100) / 100), max: Math.max(0, Math.round(amount * 100) / 100), step: "any" },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<AttachMoneyIcon />}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <FormControl fullWidth>
                                    <InputLabel id="payment-device-select-label">Payment Device</InputLabel>
                                    <Select
                                        labelId="payment-device-select-label"
                                        id="payment-device-select"
                                        value={selectedBlockchypTerminal}
                                        label="Payment Device"
                                        onChange={(event) => {
                                            setSelectedBlockchypTerminal(event.target.value)
                                            localStorage.setItem(`selected_blockchyp_terminal:location_${selectedLocation.id}`, event.target.value)
                                        }}
                                    >
                                        {(selectedLocation?.integrations?.BLOCKCHYP?.TERMINAL_NAMES ?? []).sort().map((device, index) =>
                                            <MenuItem key={index} value={device}>{device}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit" disabled={parseFloat(paymentAmount) === 0}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>)
    );
}
